import { OnboardingStatus } from '@/entities/onboarding-status';

export type OnboardingProgress = {
	// Where the request stands, e.g. "Completa tu pago".
	stepLabel: string;
	description: string;
	actionLabel: string;
	// The user only waits; the action shows details instead of a task.
	isWaiting: boolean;
};

/**
 * Whether the dashboard may offer to cancel the request: exactly what the
 * abandon endpoint accepts, a certificate holder's unpaid request that has
 * not reached review.
 */
export function canCancelFromDashboard(
	status: OnboardingStatus | null,
): boolean {
	return (
		!!status &&
		status.has_active_certificate &&
		status.payment_status !== 'PAID' &&
		status.step !== 'IN_REVIEW' &&
		status.step !== 'COMPLETED'
	);
}

/**
 * What the dashboard says about a request in flight, or null when there is
 * nothing to show (no process yet, still on the form, or finished).
 */
export function describeOnboardingProgress(
	status: OnboardingStatus | null,
): OnboardingProgress | null {
	switch (status?.step) {
		case 'SMS_VERIFICATION':
			return {
				stepLabel: 'Confirma tu teléfono',
				description:
					'Te enviaremos un código por SMS para confirmar tu número.',
				actionLabel: 'Confirmar teléfono',
				isWaiting: false,
			};
		case 'PAYMENT':
			return status.payment_status === 'PENDING'
				? {
						stepLabel: 'Pago en proceso',
						description:
							'Estamos confirmando tu pago. Si no lo completaste, puedes retomarlo.',
						actionLabel: 'Continuar con el pago',
						isWaiting: false,
					}
				: {
						stepLabel: 'Completa tu pago',
						description:
							'Realiza el pago para continuar con la verificación de tu identidad.',
						actionLabel: 'Ir al pago',
						isWaiting: false,
					};
		case 'KYC':
			return {
				stepLabel: 'Verifica tu identidad',
				description:
					'Necesitarás tu celular para grabar unas selfies y tomar fotos de tu DPI.',
				actionLabel: 'Verificar identidad',
				isWaiting: false,
			};
		case 'IN_REVIEW':
			return {
				stepLabel: 'En revisión',
				description:
					'Estamos revisando tu verificación de identidad. Te avisaremos por correo cuando tu firma esté lista.',
				actionLabel: 'Ver detalles',
				isWaiting: true,
			};
		default:
			return null;
	}
}
